import "./App.css";
import Footer from "./pages/fragments/Footer";
import Header from "./pages/fragments/Header";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { domain } from "./data";
import { Container } from "@mui/material";

export default function App({ children }) {
	useEffect(() => {
		const changeLogo = () => {
			document.title = domain;
		};

		changeLogo();
	}, []);

	return (
		<Container
			maxWidth="xl"
			className=""
			sx={{
				padding: 0,
				overflow: "hidden",
				bgcolor: "black",
			}}>
			{" "}
			<Header />
			<main className="  overflow-hidden">
				<Outlet />
			</main>
			<Footer />
		</Container>
	);
}
